/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Negotiation_Copy_Script_TooltipInputs */

const en_negotiation_copy_script_tooltip = /** @type {(inputs: Negotiation_Copy_Script_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy script to clipboard`)
};

const de_negotiation_copy_script_tooltip = /** @type {(inputs: Negotiation_Copy_Script_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy script to clipboard`)
};

const fr_negotiation_copy_script_tooltip = /** @type {(inputs: Negotiation_Copy_Script_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy script to clipboard`)
};

const es_negotiation_copy_script_tooltip = /** @type {(inputs: Negotiation_Copy_Script_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy script to clipboard`)
};

const it_negotiation_copy_script_tooltip = /** @type {(inputs: Negotiation_Copy_Script_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy script to clipboard`)
};

const nl_negotiation_copy_script_tooltip = /** @type {(inputs: Negotiation_Copy_Script_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy script to clipboard`)
};

const pl_negotiation_copy_script_tooltip = /** @type {(inputs: Negotiation_Copy_Script_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy script to clipboard`)
};

const fi_negotiation_copy_script_tooltip = /** @type {(inputs: Negotiation_Copy_Script_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy script to clipboard`)
};

const da_negotiation_copy_script_tooltip = /** @type {(inputs: Negotiation_Copy_Script_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy script to clipboard`)
};

const sv_negotiation_copy_script_tooltip = /** @type {(inputs: Negotiation_Copy_Script_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy script to clipboard`)
};

/**
* | output |
* | --- |
* | "Copy script to clipboard" |
*
* @param {Negotiation_Copy_Script_TooltipInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const negotiation_copy_script_tooltip = /** @type {((inputs?: Negotiation_Copy_Script_TooltipInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Negotiation_Copy_Script_TooltipInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_negotiation_copy_script_tooltip(inputs)
	if (locale === "fr") return fr_negotiation_copy_script_tooltip(inputs)
	if (locale === "es") return es_negotiation_copy_script_tooltip(inputs)
	if (locale === "it") return it_negotiation_copy_script_tooltip(inputs)
	if (locale === "nl") return nl_negotiation_copy_script_tooltip(inputs)
	if (locale === "pl") return pl_negotiation_copy_script_tooltip(inputs)
	if (locale === "fi") return fi_negotiation_copy_script_tooltip(inputs)
	if (locale === "da") return da_negotiation_copy_script_tooltip(inputs)
	if (locale === "sv") return sv_negotiation_copy_script_tooltip(inputs)
	return en_negotiation_copy_script_tooltip(inputs)
});